module.exports = __webpack_public_path__ + "assets/img/Lokyata-Landing-Page-+-Website-w540.67f855d3.webp";